// @flow
/**
 * Created by Mike Chung on 2/14/18.
 */

import type {ProfileUpdateActionCollection} from "../actions/profile/profileUpdateAction";
import type {ProfileLoadAction} from "../actions/profile/profileLoadAction";
import type {LogoutAction} from "../actions/profile/logoutAction";

export type ProfileState = {
    name: string
}

const INITIAL_STATE: ?ProfileState = null;

export default function reducer(state: ?ProfileState = INITIAL_STATE, action: ProfileUpdateActionCollection | ProfileLoadAction | LogoutAction) {

    switch (action.type) {
        case "profile/UPDATE_SUCCESS_ACTION":
            return Object.assign(action.profile);
        case "profile/LOAD_ACTION":
            return action.profile ? Object.assign(action.profile) : null;
        case "profile/LOGOUT_ACTION":
            return null;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ProfileReducer.js